import makeCrud from '@/store/site/localization/crud'

const module = makeCrud('manager_invoice')

// Faturayı ödendi işaretle (custom action)
module.actions.markPaid = async function ({ dispatch }, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_invoice') + '/' + id + '/mark-paid')
    return res.data
}

export default module
